import React from "react";
import { Field } from "react-final-form";
import { FormGroup, Label, Col, Alert } from "reactstrap";

import { CKEditorField, ReactSelect, required } from "modules/4_final_form/web";

import { Block } from "framework7-react";

import Interweave from "interweave";


export const AlertFieldAttributes = ({ fieldName }) => {
  return (
    <div>
      <FormGroup row>
        <Label md={12}>Alert Text</Label>
        <Col md={12}>
          <Field name={`${fieldName}.text`} component={CKEditorField} validate={required} height="500px" />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={12}>Color</Label>
        <Col md={12}>
          <Field
            name={`${fieldName}.color`}
            component={ReactSelect}
            validate={required}
            options={[
              { value: "primary", label: "Primary" },
              { value: "secondary", label: "Secondary" },
              { value: "success", label: "Success" },
              { value: "danger", label: "Danger" },
              { value: "warning", label: "Warning" },
              { value: "info", label: "Info" },
              { value: "light", label: "Light" },
              { value: "dark", label: "Dark" },
            ]}
          />
        </Col>
      </FormGroup>
    </div>
  );
};

export const AlertFieldForm = (props) => {
  const { text, color } = props;
  return (
    <div className="mt-2 mb-2">
      <Alert color={color}>
        <Interweave content={text} />
      </Alert>
    </div>
  );
};

export const MobileAlertFieldForm = (props) => {
  const { text, color } = props;

  let adjustedColor = null;

  switch (color) {
    case "primary":
      adjustedColor = "#0d6efd";
      break;
    case "secondary":
      adjustedColor = "#6c757d";
      break;
    case "success":
      adjustedColor = "#198754";
      break;
    case "danger":
      adjustedColor = "#dc3545";
      break;
    case "warning":
      adjustedColor = "#ffc107";
      break;
    case "info":
      adjustedColor = "#0dcaf0";
      break;
    case "light":
      adjustedColor = "#f8f9fa";
      break;
    case "dark":
      adjustedColor = "#212529";
      break;
    default:
      adjustedColor = "#ffffff";
  }

  return (
    <Block strong inset style={{ backgroundColor: adjustedColor }}>
      <Interweave content={text} />
    </Block>
  );
};
